import Player from '@vimeo/player';

const modalLinks = document.querySelectorAll('.modal__link');
const vimeoLinks = document.querySelectorAll('a[href*="vimeo.com"]');
let modalContainer;

const loadModal = (e) => {
    e.preventDefault();
    modalContainer.innerHTML = document.getElementById(e.currentTarget.getAttribute('data-modal-id')).innerHTML;
    openModal();
};

const loadVideoModal = (e) => {
    e.preventDefault();
    let modalContent = document.createElement('div');
    modalContent.classList.add('modal__video-content');
    modalContent.innerHTML = '<button type="button" class="modal__close c-btn c-btn-secondary" aria-label="Close"><span>Close</span></button>';
    let iframeWrapper = document.createElement('div');
    iframeWrapper.classList.add('iframe-wrapper');

    modalContent.append(iframeWrapper);
    modalContainer.append(modalContent);

    let player = new Player(iframeWrapper, {
        id: e.currentTarget.getAttribute('href'),
        autoplay: true
    });

    openModal();
};

const openModal = () => {
    modalContainer.classList.add('active');
    document.addEventListener('keydown', closeMenuOnEsc);
    document.body.classList.add('lock-scroll');

    let closeButton = modalContainer.querySelector('.modal__close');

    if (closeButton) {
        closeButton.addEventListener('click', closeModal);
    }
};

const closeModal = (e) => {
    modalContainer.classList.add('closing');
    document.body.classList.remove('lock-scroll');
                
    setTimeout(function() {
        modalContainer.classList.remove('closing', 'active');
        modalContainer.innerHTML = '';
    }, 400);
};

const closeMenuOnEsc = (e) => {
    if (e.key === 'Escape') {
        closeModal();
    }
};

const modal = () => {
    if (modalLinks.length || vimeoLinks.length) {
        modalContainer = document.createElement('div');
        modalContainer.classList.add('modal');
        document.body.append(modalContainer);
    }

    if (modalLinks.length) {
        modalLinks.forEach(modalLink => {
            modalLink.addEventListener('click', loadModal);
        });
    }

    if (vimeoLinks.length) {
        vimeoLinks.forEach(vimeoLink => {
            vimeoLink.addEventListener('click', loadVideoModal);
        });
    }
};

export { modal };